import React, { useState } from "react";
import Registration from "../Authentification/Authentification";
import { BorderBottom } from "@mui/icons-material";
import "./Header.css";

const Header = ({ menuChoice, setmenuChoice }) => {
  return (
    <div className="contenerHeader">
      {<Registration />}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginLeft: "45px",
        }}
      >
        <img
          src={"/images/LogoNoText.png"}
          alt="Avatar"
          style={{
            width: "60px",
            marginRight: "50px",
            cursor: "pointer",
          }}
          onClick={() => setmenuChoice(0)}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <img
          src={"/images/Generic-avatar.png"}
          alt="Avatar"
          style={{
            width: "33px",
            height: "33px",
            marginRight: "50px",
            cursor: "pointer",
          }}
          onClick={() => setmenuChoice(4)}
        />
      </div>
    </div>
  );
};

export default Header;
